import { Column, ModelBase } from 'loca-boot-core'

// 换电站，充电桩选项
export type CountyLayoutConfigItem = {
  itemCode: string
  itemDesc: string
}

// 时间维度筛选配置
export type CountyLayoutConfig = {
  countyLayoutConfigList: CountyLayoutConfigItem[]
  currentIndex: number
}

export class DetailItem extends ModelBase {
  @Column()
  public coverage!: number

  @Column()
  public stationCounts!: number

  @Column()
  public regionName!: string

  @Column()
  public regionCode!: string

  @Column()
  public regionCodeType!: string
}

export class LayoutDetail extends ModelBase {
  @Column()
  public coverage!: number

  @Column()
  public stationCounts!: number

  @Column({ childType: DetailItem, autowired: true })
  public detail!: DetailItem[]

  @Column()
  public building!: number
}
export class RegionList extends ModelBase {
  @Column({ childType: DetailItem, autowired: true })
  public regions!: DetailItem[]
}
